import { Service, Token } from 'typedi';
import { IPostMessageHandler } from '../post-message';
import { Lock } from '../utils/lockUtil';
import { BaseModuleLoader } from '../../loaders/BaseModuleLoader';

const moduleLock = new Lock();

export const CtaHandlerToken = new Token<IPostMessageHandler>('CtaHandler');

@Service()
export class CtaHandlerLoader extends BaseModuleLoader<IPostMessageHandler> {
    constructor() {
        super('CtaHandlerLoader');
    }

    protected _createModuleInstance = async (): Promise<IPostMessageHandler> => {
        const { CtaHandler } = await import(
            /* webpackChunkName: "cta-handler/handler" */
            './cta-handler'
        );

        return new CtaHandler();
    };

    protected override _getModuleLock = (): Lock => moduleLock;
    protected override _getToken = (): Token<IPostMessageHandler> => CtaHandlerToken;
}
